import { useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import SelectEmployeeDrawer from "./SelectEmployeeDrawer/SelectEmployeeDrawer";
import TravelerPickerSelectEmployeeContent from "./TravelerPickerSelectEmployeeContent";
import { FormValues } from "./types";

const setValueConfig = {
  shouldDirty: true,
  shouldTouch: true,
};

export default function TravelerPickerSelectEmployee() {
  const [isVisible, setIsVisible] = useState(false);

  const { control, setValue } = useFormContext<FormValues<any>>();
  const [initialEmployeeList, nonEmployee] =
    useWatch({ control, name: ["employees", "nonEmployee"] }) || [];

  return (
    <>
      <TravelerPickerSelectEmployeeContent
        onOpenEmployeePicker={() => setIsVisible(true)}
      />
      {isVisible && (
        <SelectEmployeeDrawer
          isVisible
          onClose={() => setIsVisible(false)}
          onSubmit={(value) =>
            setValue("employees", value.selectedEmployees, setValueConfig)
          }
          initialEmployeeList={initialEmployeeList}
          nonEmployeeAdults={nonEmployee?.adults || 0}
          nonEmployeeChildren={nonEmployee?.children || 0}
        />
      )}
    </>
  );
}
